export default "__VITE_ASSET__G_GPjd3X__"